module.exports = __webpack_public_path__ + "assets/img/course-act-bg1.9d0973b0.png";